<!--
 * @Author: your name
 * @Date: 2020-11-16 20:27:10
 * @LastEditTime: 2022-12-07 16:34:11
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/error/index.vue
-->
<style scoped lang="sass">
.error_page
  display: flex
  flex-direction: column
  align-items: center
  padding-top: 72PX

  .error_img
    height: 120PX
    width: 120PX
    margin-bottom: 10px

  .error_content
    padding: 0 70PX
    line-height: 34PX
    text-align: center
    font-size: 29PX
    color: var(--menu-primary-background-colour)

  .error_text
    font-size: 15PX
    line-height: 15PX
    margin-top: 25PX
    margin-left: 10px
    margin-right: 10px
    text-align: center
    color: var(--menu-primary-text-colour)
</style>

<template lang="pug">
.box
  .error_page
    img.error_img(:src="errorPageImg")
    .error_content.b Oops! Something went wrong.
    .error_text.o75 This venue cannot be found.
    .error_text.o75 Please rescan your QR code or ensure you have entered the correct URL to view the menu.
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import resizeHandler from 'utils/resizeHandler'
@Component({
  mixins: [resizeHandler],
  watch: {
    time(num) {
      // if (!num) this._goToSite()
    }
  }
})

class ErrorPage extends Vue {
  time = 0
  errorPageImg = require('@/assets/errorPagePic/error-404.png')

  mounted() {
    this.time = 4
    setInterval(this._countDown, 1000)
  }

  // count down
  // 倒计时
  _countDown() {
    this.time--
  }

  _goToSite() {
    if (self !== top) {
      // Iframe sends data to father
      // iframe 发送数据给父亲
      window.top.postMessage({
        name: 'goToSite',
      }, '*')
    } else {
      this.$router.push({
        path: '/site'
      })
    }
  }
}

export default ErrorPage
</script>
